import React from "react";

import { GMN } from "@nens/brostar/openapi-client";
import { ColumnDefinition } from "@nens/chakra/components";
import { removeNullUndefined } from "@nens/shared-utils";

import { TableOverview } from "@/components/table-overview";
import { renderDefault } from "@/helpers/table-render-functions";
import { useAllFetchedPagination } from "@/hooks/use-pagination";
import { KEY_ADDON_MAP } from "@/hooks/use-router-table-data";
import { useGmnListAllPagesQuery } from "@/queries/query-gmn";

import { gmnInformation } from "./types";

const columnDefinitions: ColumnDefinition<GMN>[] = gmnInformation.map(({ key, label }) => ({
  title: label,
  renderFunction: (row) => renderDefault(row[key]),
  width: "1fr",
}));

type Props = {
  receiveSelectedBroIds: (selected: string[]) => void;
  defaultSelectedBroIds?: string[];
};

const SelectGmnTable: React.FC<Props> = ({ receiveSelectedBroIds, defaultSelectedBroIds }) => {
  const { data } = useGmnListAllPagesQuery();
  const gmns = data?.results ?? [];

  const { paginatedTableData, ...paginationProps } = useAllFetchedPagination(
    KEY_ADDON_MAP.SELECT_GMN,
    gmns
  );

  const recieveSelectedUuid = (selected: { uuid: string }[]) => {
    const selectedBroIds = selected.map(
      ({ uuid }) => gmns.find((gmn) => gmn.uuid === uuid)?.broId as string
    );
    receiveSelectedBroIds(selectedBroIds);
  };

  const defaultSelectedUuids = removeNullUndefined(
    (defaultSelectedBroIds ?? []).map((broId) => {
      const uuid = gmns.find((gmn) => gmn.broId === broId)?.uuid;
      if (uuid) {
        return { uuid };
      } else {
        return null;
      }
    })
  );

  return (
    <TableOverview
      paginationProps={paginationProps}
      tableData={paginatedTableData}
      columnDefinitions={columnDefinitions}
      sendSelected={recieveSelectedUuid}
      defaultSelected={defaultSelectedUuids}
    ></TableOverview>
  );
};

export { SelectGmnTable };
